// ./config/introConversations.js
import { getAssetUrl } from '../api/config';

const introConversations = {
    it: {
        // General introduction (before hiding game)
        general: [
            {
                name: 'Mars',
                text: 'Ciao sono Mars. Sono un Marziano e viaggio nello spazio. Io e miei amici vogliamo giocare con te. Clicca su avanti visita con me i pianeti lontani dove possiamo giocare con i miei amici.',
                audio: getAssetUrl('/audios/storyline/it/mars1.wav'),
                autoNext: false
            },
            {
                name: 'Mars',
                text: 'Scegli un pianeta da visitare e facciamo un gioco con i miei amici.',
                audio: getAssetUrl('/audios/storyline/it/mars2.wav')
            },
        ],
        
        // Exercise-specific conversations
        hidingGame: [
            {
                name: 'Mars',
                text: 'Che bello! Facciamo il gioco del nascondino. Io mi nascondo su un pianeta e tu mi devi cercare. Quando mi trovi, toccami. Clicca il pianeta sul quale mi nascondo.',
                audio: getAssetUrl('/audios/storyline/it/mars3.wav')
            },
            {
                name: 'Mars',
                text: 'Bene. Siamo pronti? Clicca su avanti per incominciare.',
                audio: getAssetUrl('/audios/storyline/it/mars4.wav'),
                autoNext: false
            },
        ],
        
        syllables: [
            {
                name: 'Mars',
                autoNext: true,
                timestamps: [
                    { name: 'Mars', time: 0, text: 'Per fare questo gioco andiamo sul sul pianeta verde a giocare con Dudi, il mio amico marziano. '},
                    { name: 'Mars', time: 10, text: 'Bene io sono pronto. Partiamo! Pronti, partenza accendiamo i motori, decollo!' },
                    { name: 'Mars', time: 25, text: 'Ecco il pianeta verde. Siamo quasi arrivati. Prepariamoci per l\'atterraggio.' },
                    { name: 'Mars', time: 33, text: 'Oh, nooo. Il mio razzo sta esplodendo!' },
                    { name: 'Mars', time: 39, text: 'Oh, noo. Il mio razzo è tutto rotto. Come faccio a viaggiare adesso.' },
                    { name: 'Dudi', time: 49, text: 'Ciao Mars, cosa è successo?' },
                    { name: 'Mars', time: 53, text: 'Ciao Dudi, il mio razzo si è rotto. Puoi aiutarmi ad aggiustarlo?'},
                    { name: 'Dudi', time: 60, text: 'Certo amico mio. Ma sai, che a me piace cantare le canzoni dei Marziani e voglio che tu e tuoi amici del pianeta terra cantate con me.'},
                    { name: 'Dudi', time: 71, text: 'Per ogni canzone che cantate io vi darò un nuovo pezzo del tuo razzo. Mi raccomando. Dovete cantare molto bene.'},
                    { name: 'Mars', time: 81, text: 'Certo Dudi anche a me piace cantare. Amici cantiamo con Dudi e vinciamo i pezzi del razzo. Quando siete pronti cliccate su avanti.'}
                ],
                scene: {
                    video: getAssetUrl('/videos/landing.mp4'),
                    videoLoop: false,
                    videoMuted: false,
                    hideCharacters: true,
                }
            },
            {
                name: 'Mars',
                text: 'Bene. Come prima cosa dobbiamo mettere le cuffie ed aggiustare il microfono. Quando siete pronti cliccate su "Avanti→".',
                audio: getAssetUrl('/audios/storyline/it/mars13.wav'),
                autoNext: false
            },
            {
                name: 'Mars',
                text: '1,2,3 prova. Mi senti? Se mi senti ripeti dopo di me: BA BA BU BU.',
                audio: getAssetUrl('/audios/storyline/it/mars14.wav'),
                autoNext: false,
                scene: {
                    component: 'MicTest'
                }
            },
            {
                name: 'Mars',
                text: 'Facciamo una prova. Premi Avanti, e dopo premi il bottone giallo per incominciare',
                audio: getAssetUrl('/audios/storyline/it/mars15_new.wav'),
                autoNext: false
            }
        ],
        
        
        nonWords: [
    {
        name: 'Mars',
        text: 'Bravissimo! Ora giochiamo con parole inventate!'
    },
    {
        name: 'Pepè',
        text: 'Ciao! Io sono Pepè e ti aiuterò con le non-parole.'
    },
    {
        name: 'Mars',
        text: 'Ripeti dopo di noi le parole inventate!'
    },
],
    
    sentences: [
    {
        name: 'Mars',
        text: 'Eccellente! Hai trovato tutti i nascondigli!'
    },
    {
        name: 'Niron',
        text: 'Ciao! Sono Niron e ti aiuterò con le frasi.'
    },
    {
        name: 'Mars',
        text: 'Ascolta le frasi e ripetile dopo di noi!'
    },
],
    
    // UI Text
    nextButton: 'Avanti →'
},

en: {
    // General introduction (before hiding game)
    general: [
        {
            name: 'Mars',
            text: 'Hello! I am MARS the Martian and I travel through space!',
            audio: getAssetUrl('/audios/introduction/en/hello_im_mars.mp3')
        },
    ],
        
        // Exercise-specific conversations
        
        hidingGame: [
        {
            name: 'Mars',
            text: 'Hello! I am MARS the Martian and I travel through space!',
            audio: getAssetUrl('/audios/introduction/en/hello_im_mars.mp3')
        },
        {
            name: 'Mars',
            text: 'Before we start, let\'s play hide and seek among the planets!'
        },
        {
            name: 'Mars',
            text: 'Let\'s play a game! Find which planet I\'m hiding on.',
            audio: getAssetUrl('/audios/introduction/en/lets_play_game.mp3')
        },
    ],
        
        syllables: [
        {
            name: 'Mars',
            text: 'Oh no! My spaceship is broken and the pieces are scattered everywhere!'
        },
        {
            name: 'Tony',
            text: 'Haha! I found them, Mars! But I\'ll only give them back if you sing some songs for me!'
},
    {
        name: 'Mars',
            text: 'Alright Tony, I like challenges! Get ready to hear my intergalactic voice!'
    },
    {
        name: 'Tony',
            text: 'Perfect! Every time you sing well, I\'ll return a piece of the spaceship.'
    },
    {
        name: 'Mars',
            text: 'Let\'s start right away, I can\'t wait to fly among the stars again!'
    },
],
    
    nonWords: [
        {
            name: 'Mars',
            text: 'Great job! Now let\'s play with made-up words!'
        },
        {
            name: 'Pepè',
            text: 'Hello! I\'m Pepè and I\'ll help you with non-words.'
        },
        {
            name: 'Mars',
            text: 'Repeat the made-up words after us!'
        },
    ],
        
        sentences: [
        {
            name: 'Mars',
            text: 'Excellent! You found all the hiding spots!'
        },
        {
            name: 'Niron',
            text: 'Hello! I\'m Niron and I\'ll help you with sentences.'
        },
        {
            name: 'Mars',
            text: 'Listen to the sentences and repeat them after us!'
        },
    ],
        
        // UI Text
        nextButton: 'Next →'
},

de: {
    // General introduction (before hiding game)
    general: [
        {
            name: 'Mars',
            text: 'Hallo! Ich bin MARS der Marsianer und reise durch das Weltall!',
            audio: getAssetUrl('/audios/introduction/de/hallo_ich_bin_mars.mp3')
        },
        {
            name: 'Mars',
            text: 'Bevor wir anfangen, spielen wir Verstecken zwischen den Planeten!'
        },
        {
            name: 'Mars',
            text: 'Lass uns ein Spiel spielen! Finde heraus, auf welchem Planeten ich mich verstecke.',
            audio: getAssetUrl('/audios/introduction/de/lass_uns_spielen.mp3')
        },
    ],
        
        // Exercise-specific conversations
        
        hidingGame: [
        {
            name: 'Mars',
            text: 'Hallo! Ich bin MARS der Marsianer und reise durch das Weltall!',
            audio: getAssetUrl('/audios/introduction/de/hallo_ich_bin_mars.mp3')
        },
        {
            name: 'Mars',
            text: 'Bevor wir anfangen, spielen wir Verstecken zwischen den Planeten!'
        },
        {
            name: 'Mars',
            text: 'Lass uns ein Spiel spielen! Finde heraus, auf welchem Planeten ich mich verstecke.',
            audio: getAssetUrl('/audios/introduction/de/lass_uns_spielen.mp3')
        },
    ],
        
        syllables: [
        {
            name: 'Mars',
            text: 'Oh nein! Mein Raumschiff ist kaputt und die Teile sind überall verstreut!'
        },
        {
            name: 'Tony',
            text: 'Haha! Ich habe sie gefunden, Mars! Aber ich gebe sie dir nur zurück, wenn du mir ein paar Lieder vorsingst!'
        },
        {
            name: 'Mars',
            text: 'Okay Tony, ich mag Herausforderungen! Mach dich bereit, meine intergalaktische Stimme zu hören!'
        },
        {
            name: 'Tony',
            text: 'Perfekt! Jedes Mal, wenn du gut singst, gebe ich dir ein Teil des Raumschiffs zurück.'
        },
        {
            name: 'Mars',
            text: 'Dann fangen wir gleich an, ich kann es kaum erwarten, wieder zwischen den Sternen zu fliegen!'
        },
    ],
        
        nonWords: [
        {
            name: 'Mars',
            text: 'Sehr gut! Jetzt spielen wir mit erfundenen Wörtern!'
        },
        {
            name: 'Pepè',
            text: 'Hallo! Ich bin Pepè und helfe dir mit Nicht-Wörtern.'
        },
        {
            name: 'Mars',
            text: 'Wiederhole die erfundenen Wörter nach uns!'
        },
    ],
        
        sentences: [
        {
            name: 'Mars',
            text: 'Ausgezeichnet! Du hast alle Verstecke gefunden!'
        },
        {
            name: 'Niron',
            text: 'Hallo! Ich bin Niron und helfe dir mit Sätzen.'
        },
        {
            name: 'Mars',
            text: 'Höre die Sätze und wiederhole sie nach uns!'
        },
    ],
        
        // UI Text
        nextButton: 'Weiter →'
},

zh: {
    // General introduction (before hiding game)
    general: [
        {
            name: 'Mars',
            text: '你好！我是火星人MARS，我在太空中旅行！',
            audio: getAssetUrl('/audios/introduction/zh/nihao_wo_shi_mars.mp3')
        },
        {
            name: 'Mars',
            text: '在开始之前，我们来玩行星间的捉迷藏吧！'
        },
        {
            name: 'Mars',
            text: '我们来玩个游戏！找找我藏在哪个星球上。',
            audio: getAssetUrl('/audios/introduction/zh/women_lai_wan_youxi.mp3')
        },
    ],
        
        // Exercise-specific conversations
        
        hidingGame: [
        {
            name: 'Mars',
            text: '你好！我是火星人MARS，我在太空中旅行！',
            audio: getAssetUrl('/audios/introduction/zh/nihao_wo_shi_mars.mp3')
        },
        {
            name: 'Mars',
            text: '在开始之前，我们来玩行星间的捉迷藏吧！'
        },
        {
            name: 'Mars',
            text: '我们来玩个游戏！找找我藏在哪个星球上。',
            audio: getAssetUrl('/audios/introduction/zh/women_lai_wan_youxi.mp3')
        },
    ],
        
        syllables: [
        {
            name: 'Mars',
            text: '糟糕！我的宇宙飞船坏了，零件散落一地！'
        },
        {
            name: 'Tony',
            text: '哈哈！我找到了，Mars！但只有你唱歌给我听，我才会还你零件！'
        },
        {
            name: 'Mars',
            text: '好吧Tony，我喜欢挑战！准备好听我的星际歌声吧！'
        },
        {
            name: 'Tony',
            text: '太好了！每次你唱得好，我就还你一块飞船零件。'
        },
        {
            name: 'Mars',
            text: '那我们马上开始，我迫不及待想再次在星空中飞翔了！'
        },
    ],
        
        nonWords: [
        {
            name: 'Mars',
            text: '太棒了！现在我们来玩虚构词汇！'
        },
        {
            name: 'Pepè',
            text: '你好！我是Pepè，我会帮助你练习非词汇。'
        },
        {
            name: 'Mars',
            text: '跟着我们重复这些虚构的词汇！'
        },
    ],
        
        sentences: [
        {
            name: 'Mars',
            text: '太棒了！你找到了所有的藏身之处！'
        },
        {
            name: 'Niron',
            text: '你好！我是Niron，我会帮助你练习句子。'
        },
        {
            name: 'Mars',
            text: '听句子然后跟着我们重复！'
        },
    ],
        
        // UI Text
        nextButton: '下一步 →'
}
};

export const getIntroConversation = (languageCode, exerciseId) => {
    const lang = introConversations[languageCode] || introConversations['it']; // Default to Italian
    return lang[exerciseId] || [];
}

export const getNextButtonText = (languageCode) => {
    const lang = introConversations[languageCode] || introConversations['it'];
    return lang.nextButton;
};

export default introConversations;
